module.exports = __webpack_public_path__ + "img/play-solid.f79fe6ae.svg";